import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {TYPE} from '../../models/type.enum';

@Component({
  selector: 'cmp-alerts-info',
  template: `<ngb-alert *ngIf="active && message"
           (click)="onActionClick.emit(null)"
           [dismissible]="false"
           [class]="classType"
           [type]="type">
  {{ message }}
</ngb-alert>
`,
  styles: [`.alert-info{position:fixed;bottom:15px;right:15px;text-align:left;z-index:1200}`]
})
export class AlertsInfoComponent implements OnChanges {

  @Input() message: any;
  @Input() timeHide = 5000;
  @Input() active = false;
  @Input() type: TYPE = TYPE.PRIMARY;
  @Output() onActionClick = new EventEmitter();
  classType: any;
  timeRe: any;

  reloadTimer() {
    if (this.timeRe) {
      clearTimeout(this.timeRe);
    }
    if (this.timeHide) {
      this.timeRe = setTimeout(() => {
        this.active = false;
      }, this.timeHide);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.active = true;
    this.reloadTimer();
  }

}
